export default __webpack_public_path__ + "static/media/WM0480.34I-43865_-26181_0.8a3b7581.jpg";